import { AccountCenter } from './AccountCenter';
import { connectAccountCenter } from './AccountCenter.connect';

export const ConnectedAccountCenter = connectAccountCenter(AccountCenter);
